export const statisticSurveyPeriods: TableModule = {
    name: "statisticSurveyPeriods",
    route: "spa.statistics.statisticSurveyPeriods",
    defaultOrder: {
        column: "start_date",
        direction: "desc"
    },
    columns: [
        {
            name: "start_date",
            sortable: true,
            mobile: true
        }, {
            name: "end_date",
            sortable: true,
        }, {
            name: "recording_start_date",
            sortable: true,
            mobile: true
        }, {
            name: "recording_end_date",
            sortable: true,
        }
    ],
    tools: [
        {
            isCreateAction: true,
            ability: ["update", "statisticSurveys"]
        }
    ]
}
